
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinphulegaon() {



const cardData = {
  keyword: 'Corporate Cab and Bus Services in Phulgaon MIDC',
  heading: 'eTravo: Corporate Cab and Bus Services in Phulgaon MIDC',
  headingDescription: `eTravo offers professional and cost-effective corporate cab and bus services in Phulgaon MIDC, a growing industrial zone near Pune known for its manufacturing units, agro-processing facilities, and logistics centers. Designed to meet the daily commute and operational transport needs of industries, our services ensure smooth and timely employee and executive movement across the area.`,

  top: 'Top Places to visit in Pune with eTravo',
"topPlaces": [
  {
    "title": "Khed City Industrial Park",
    "description": "Khed City is a 4,200-acre integrated industrial township developed by the Kalyani Group and MIDC. It hosts global and Indian companies like Mars International, Maxion Wheels, Amul, and Hyosung. eTravo provides tailored employee transportation solutions, ensuring efficient and timely commutes within this expansive industrial zone."
  },
  {
    "title": "Rajgurunagar (formerly Khed) Town Center",
    "description": "Rajgurunagar serves as the administrative headquarters of Khed Taluka. With its strategic location on the Pune-Nashik Highway, it is a hub for commerce and governance. eTravo offers reliable cab services for residents, officials, and visitors, facilitating smooth travel within and beyond the town."
  },
  {
    "title": "Hutatma Rajguru Mahavidyalaya",
    "description": "This prominent educational institution offers undergraduate and postgraduate programs in Arts, Commerce, and Science. eTravo ensures safe and punctual transportation for students and faculty, supporting academic pursuits in the region."
  },
  {
    "title": "Sahyadri School (Krishnamurti Foundation India)",
    "description": "Located near Tiwai Hill, Sahyadri School provides holistic education amidst nature. eTravo caters to the transportation needs of students and staff, ensuring comfortable travel to this serene campus."
  },
  {
    "title": "Dilawar Khan's Tomb and Mosque",
    "description": "A 17th-century Mughal-era monument, this site is a testament to the region's rich history. eTravo offers guided tour transportation services, allowing history enthusiasts to explore this architectural marvel conveniently."
  },
  {
    "title": "Khed Railway Station",
    "description": "Situated on the Konkan Railway line, Khed Railway Station connects the town to major cities. eTravo provides seamless first and last-mile connectivity, ensuring travelers reach their destinations on time."
  },
  {
    "title": "Chas-Kaman Dam",
    "description": "A vital water reservoir near Khed, it supports irrigation and water supply in the region. eTravo facilitates visits for professionals and tourists interested in environmental and infrastructural studies."
  },
  {
    "title": "Government ITI Khed",
    "description": "This Industrial Training Institute offers vocational courses, enhancing skill development in the area. eTravo supports students with dependable transportation options, aiding in their educational journey."
  },
  {
    "title": "Khed Bus Stand",
    "description": "A central hub for road transport, connecting Khed to various parts of Maharashtra. eTravo complements public transport by offering flexible cab services for travelers and daily commuters."
  },
  {
    "title": "Local Markets and Commercial Areas",
    "description": "Khed's bustling markets are centers of trade and daily life. eTravo provides convenient transportation for shoppers and business owners, ensuring easy access to these commercial zones."
  }
],

services: [
  {
    name: 'Corporate Commute Phulgaon MIDC',
    description: `Comprehensive monthly corporate commute services in Phulgaon MIDC. Designed to support daily employee travel with reliable vehicles, trained drivers, and shift-based scheduling.`
  },
  {
    name: 'Bus & Cab Hire for Phulgaon Companies',
    description: `Flexible monthly bus and cab hire services for companies operating in Phulgaon. Provides both AC and non-AC vehicles with professional chauffeurs and GPS tracking for safety.`
  },
  {
    name: 'Reliable Staff Pickup & Drop Services Phulgaon',
    description: `Dependable staff pickup and drop services across Phulgaon, ensuring punctuality and safety. Ideal for businesses requiring organized daily transport with fixed or dynamic routes.`
  },
  {
    name: 'Budget Office Shuttle Solutions Phulgaon',
    description: `Cost-effective shuttle services tailored for office staff in Phulgaon. Monthly plans help reduce commute costs while maintaining reliable and comfortable transportation.`
  },
  {
    name: 'AC Cab Rentals for Industrial Areas Phulgaon',
    description: `Air-conditioned cab rentals for industrial zones in Phulgaon. Offers clean, comfortable vehicles suitable for executive and employee transport on monthly contracts.`
  },
  {
    name: 'Business Transport Services Phulgaon MIDC',
    description: `End-to-end business transport solutions in Phulgaon MIDC, supporting client visits, field work, and daily corporate travel with flexible vehicle options and professional drivers.`
  }
],

tableData: [
  ['Corporate Commute Phulgaon MIDC', 'Bus & Cab Hire for Phulgaon Companies'],
  ['Reliable Staff Pickup & Drop Services Phulgaon', 'Budget Office Shuttle Solutions Phulgaon'],
  ['AC Cab Rentals for Industrial Areas Phulgaon', 'Business Transport Services Phulgaon MIDC']
],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab and Bus Services in Phulgaon MIDC",
    "WhyChoosedescription": "eTravo offers dependable and efficient corporate cab and bus services in Phulgaon MIDC, ensuring seamless transportation solutions for businesses and their workforce."
  },
  {
    "WhyChooseheading": "Fleet Suitable for Industrial Workforce and Executives",
    "WhyChoosedescription": "Our fleet includes well-maintained sedans, SUVs, and high-capacity buses designed to meet the commuting needs of employees and management teams in Phulgaon MIDC."
  },
  {
    "WhyChooseheading": "Shift-Based Transport Planning for Industrial Operations",
    "WhyChoosedescription": "We provide flexible and reliable transportation aligned with shift schedules, making employee travel efficient and on time—regardless of day or night shifts."
  },
  {
    "WhyChooseheading": "Trained Drivers with Knowledge of MIDC Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in navigating Phulgaon MIDC’s industrial zones, ensuring safe and timely commutes every day."
  },
  {
    "WhyChooseheading": "Live GPS Tracking for Real-Time Monitoring",
    "WhyChoosedescription": "All vehicles are GPS-enabled for real-time tracking and improved route management, enhancing safety and transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Monthly Billing with Transparent Invoicing",
    "WhyChoosedescription": "We offer itemized and easy-to-understand monthly invoices, helping your company manage transportation budgets effectively."
  },
  {
    "WhyChooseheading": "Maintaining High Standards of Safety and Hygiene",
    "WhyChoosedescription": "Vehicles are regularly sanitized and maintained to ensure clean, safe, and hygienic travel conditions for all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Support Team and Transport Management",
    "WhyChoosedescription": "A dedicated account manager oversees your transportation plan in Phulgaon MIDC, ensuring uninterrupted service and prompt assistance."
  }
]




















}

const faqData = [
  [
    {
      question: "Which areas do your corporate cab and bus services cover?",
      answer: "We offer corporate transportation services in Pune and nearby industrial areas, including Phulgaon MIDC, Ranjangaon, Chakan, and surrounding zones."
    },
    {
      question: "Can transport plans be customized according to shifts and workforce size?",
      answer: "Yes, we provide flexible and tailored transport solutions that fit your company’s shift schedules, employee strength, and route preferences."
    },
    {
      question: "Do you offer GST-compliant billing for corporate clients?",
      answer: "Absolutely. Our monthly corporate transport plans come with consolidated GST-compliant invoices and detailed usage reports."
    },
    {
      question: "Are professional and verified drivers included in your services?",
      answer: "Yes, all drivers are background-verified, professionally trained, and experienced in handling corporate transportation safely."
    },
    {
      question: "What safety protocols do you follow for employee transportation?",
      answer: "Our vehicles are GPS-enabled, sanitized regularly, and maintained to ensure maximum safety. Drivers undergo strict verification and training."
    },
    {
      question: "Is dedicated support available for managing daily transport operations?",
      answer: "Yes, we assign dedicated coordinators and provide real-time tracking tools to ensure smooth daily commute management."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Deepak Shinde",
    designation: "Operations Manager, Phulgaon MIDC Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s transport services in Phulgaon MIDC have made employee commuting punctual and safe. Highly reliable and professional.”"
  },
  {
    name: "Ms. Anita Joshi",
    designation: "HR Head, Ranjangaon Manufacturing",
    rating: [1, 1, 1, 1, 1],
    text: "“We trust eTravo for our corporate cab and bus needs in Phulgaon MIDC. Excellent support and well-maintained vehicles.”"
  }
];
























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Phulgaon MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-phulgaon-midc.jpg",
  "description": "Book corporate cab and bus services in Phulgaon MIDC with eTravo for staff pickup & drop, office shuttle, and business transport. Reliable and affordable AC cabs and buses tailored for companies in Phulgaon Industrial Area.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-phulgaon-midc"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Cab and Bus Services in Phulgaon MIDC | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Phulgaon MIDC with eTravo for office shuttle, staff pickup & drop, and reliable business transport. Affordable AC cabs and buses for Phulgaon Industrial Area companies." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/106.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinphulegaon;